module.exports = __webpack_public_path__ + "img/smoobu-logo.078f54b9.png";